"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var _constants = require("../constants");

var range = function range(start, end) {
  return Array.from({
    length: end - start
  }, function (_, k) {
    return k + start;
  });
};

var roomsBuilder = function roomsBuilder(params, context) {
  var _a, _b;

  var bedroomCount = ((_a = params.rooms) === null || _a === void 0 ? void 0 : _a.bedroomCount) || [];
  var hasStudio = (_b = params.categories) === null || _b === void 0 ? void 0 : _b.includes(_SearchFilters.TypeValue.STUDIO); // for building the facet query for the propertyType, we want
  // to exclude the room filter.

  if (bedroomCount.length === 0 || (context === null || context === void 0 ? void 0 : context.withoutPropertyType)) {
    return '';
  }

  var query = bedroomCount.slice().sort().map(function (val) {
    if (val === _SearchFilters.RoomsValue.FOUR_AND_MORE) {
      return range(4, _constants.MaxBedroomCount + 1).map(function (count) {
        return "facility_bedroom_count:" + count + (count === _constants.MaxBedroomCount ? '+' : '');
      }).join(' OR ');
    }

    return "facility_bedroom_count:" + val;
  }).join(' OR ');

  if (hasStudio) {
    query = query + " OR facility_bedroom_count:0";
  }

  return query;
};

var _default = roomsBuilder;
exports["default"] = _default;